import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  en: {
    translation: {
      brand: "EventHub",
      subbrand: "Dakar · 7–15 October 2026",
      nav: { browse: "Sessions", myBookings: "My Bookings", media: "Media", admin: "Admin", scanner: "Door Scan" },
      filters: { all: "All", workshop: "Workshops", training: "Trainings", side_event: "Side Events" },
      day: "Day",
      hero: {
        eyebrow: "ONE LINK · ALL EVENTS",
        title: "A concierge seat, reserved for you.",
        sub: "Browse workshops, trainings and side events. Reserve with WhatsApp. Check in with a QR at the door.",
        cta: "Browse sessions",
        bulk: "Reserve every event",
      },
      featured: {
        badge: "Featured",
        dates: "7 – 15 October 2026",
        session_tag: "89th Ordinary Session · ACHPR",
        title: "Forum on the Participation of NGOs in the 89",
        title_suffix: " Ordinary Session of the African Commission on Human and Peoples' Rights",
        subtitle: "Dakar Side Events · Side sessions, workshops & trainings",
        theme_label: "Theme · 2026",
        theme_scope: "African Union Agenda 2063",
        theme_quote: "\"Assuring Sustainable Water Availability and Safe Sanitation Systems to Achieve the Goals of Agenda 2063.\"",
        two_venues: "Dakar, Senegal · Two host venues",
        reserve_multiple: "RESERVE MULTIPLE EVENTS",
      },
      session: {
        capacity: "Capacity",
        reserved: "Reserved",
        available: "Available",
        limited: "Limited",
        full: "Full · Join waitlist",
        room: "Room",
        facilitator: "Facilitator",
        reserve: "Reserve seat",
        starts: "Starts",
      },
      otp: {
        title: "WhatsApp verification",
        sub: "We'll send a 6-digit code to your WhatsApp number.",
        phonePlaceholder: "+220 XXX XXXX",
        send: "Send code",
        codeLabel: "Enter the 6-digit code",
        namePlaceholder: "Full name / Delegation",
        confirm: "Confirm reservation",
        resend: "Resend code",
        demoNotice: "DEMO MODE — OTP is shown here. In production it arrives via WhatsApp.",
      },
      overlap: {
        title: "Time conflict",
        body: "This session overlaps with existing bookings. Reserve anyway?",
        conflicts: "Conflicts",
        cancel: "Cancel",
        continue: "Reserve anyway",
      },
      bookings: {
        title: "My bookings",
        empty: "No bookings yet. Choose a session to reserve your seat.",
        qr: "QR Ticket",
        cancel: "Cancel",
        exportIcs: ".ics",
        exportGoogle: "Google",
        exportApple: "Apple",
        waitlisted: "Waitlisted — position #{{n}}",
        confirmed: "Confirmed",
        loadPrompt: "Enter your WhatsApp number to view bookings",
        load: "Load bookings",
      },
      admin: {
        title: "Admin Console",
        login: "Sign in with Google",
        loggedInAs: "Signed in as",
        logout: "Sign out",
        dashboard: "Dashboard",
        sessions: "Sessions",
        walkin: "Walk-in",
        media: "Media",
        reports: "Reports",
        admins: "Admins",
        totals: {
          bookings: "Confirmed", waitlist: "Waitlisted", checkins: "Checked in", no_show: "No-shows",
        },
        exportCsv: "Export CSV",
        walkinTitle: "Walk-in registration",
        addSession: "Add session",
        capacity: "Capacity",
        reserved: "Reserved",
      },
      scanner: {
        title: "Door check-in",
        placeholder: "Paste or type QR token",
        check: "Check in",
        ok: "Welcome!",
        duplicate: "Already checked in",
        notfound: "Ticket not found",
      },
      media: { title: "Media & Agenda", empty: "No media uploaded yet." },
      common: { close: "Close", cancel: "Cancel", loading: "Loading…" },
    },
  },
  fr: {
    translation: {
      brand: "EventHub",
      subbrand: "Dakar · 7–15 octobre 2026",
      nav: { browse: "Sessions", myBookings: "Mes réservations", media: "Médias", admin: "Admin", scanner: "Scan porte" },
      filters: { all: "Tous", workshop: "Ateliers", training: "Formations", side_event: "Événements parallèles" },
      day: "Jour",
      hero: {
        eyebrow: "UN LIEN · TOUS LES ÉVÉNEMENTS",
        title: "Un siège de concierge, réservé pour vous.",
        sub: "Parcourez les ateliers, formations et événements parallèles. Réservez via WhatsApp. Enregistrez-vous avec un QR.",
        cta: "Voir les sessions",
        bulk: "Réserver tout",
      },
      featured: {
        badge: "À la une",
        dates: "7 – 15 octobre 2026",
        session_tag: "89e Session ordinaire · CADHP",
        title: "Forum sur la participation des ONG à la 89",
        title_suffix: " Session ordinaire de la Commission africaine des droits de l'homme et des peuples",
        subtitle: "Événements parallèles de Dakar · Sessions, ateliers & formations",
        theme_label: "Thème · 2026",
        theme_scope: "Agenda 2063 de l'Union africaine",
        theme_quote: "« Garantir la disponibilité durable de l'eau et des systèmes d'assainissement sûrs pour atteindre les objectifs de l'Agenda 2063. »",
        two_venues: "Dakar, Sénégal · Deux sites hôtes",
        reserve_multiple: "RÉSERVER PLUSIEURS ÉVÉNEMENTS",
      },
      session: {
        capacity: "Capacité", reserved: "Réservé", available: "Disponible", limited: "Limité",
        full: "Complet · Liste d'attente", room: "Salle", facilitator: "Animateur",
        reserve: "Réserver", starts: "Début",
      },
      otp: {
        title: "Vérification WhatsApp",
        sub: "Nous enverrons un code à 6 chiffres sur votre WhatsApp.",
        phonePlaceholder: "+220 XXX XXXX", send: "Envoyer le code",
        codeLabel: "Entrez le code à 6 chiffres",
        namePlaceholder: "Nom complet / Délégation",
        confirm: "Confirmer la réservation", resend: "Renvoyer le code",
        demoNotice: "MODE DÉMO — le code s'affiche ici. En production, il arrive par WhatsApp.",
      },
      overlap: {
        title: "Conflit horaire",
        body: "Cette session chevauche des réservations existantes. Continuer ?",
        conflicts: "Conflits", cancel: "Annuler", continue: "Réserver quand même",
      },
      bookings: {
        title: "Mes réservations", empty: "Aucune réservation. Choisissez une session.",
        qr: "Billet QR", cancel: "Annuler",
        exportIcs: ".ics", exportGoogle: "Google", exportApple: "Apple",
        waitlisted: "Liste d'attente — position #{{n}}", confirmed: "Confirmé",
        loadPrompt: "Entrez votre numéro WhatsApp", load: "Charger",
      },
      admin: {
        title: "Console admin", login: "Se connecter avec Google", loggedInAs: "Connecté en tant que",
        logout: "Se déconnecter", dashboard: "Tableau de bord", sessions: "Sessions",
        walkin: "Sur place", media: "Médias", reports: "Rapports", admins: "Administrateurs",
        totals: { bookings: "Confirmées", waitlist: "En attente", checkins: "Enregistrés", no_show: "Absents" },
        exportCsv: "Exporter CSV", walkinTitle: "Inscription sur place",
        addSession: "Ajouter session", capacity: "Capacité", reserved: "Réservé",
      },
      scanner: { title: "Contrôle porte", placeholder: "Collez le jeton QR", check: "Valider",
        ok: "Bienvenue !", duplicate: "Déjà enregistré", notfound: "Billet introuvable" },
      media: { title: "Médias & Agenda", empty: "Aucun média." },
      common: { close: "Fermer", cancel: "Annuler", loading: "Chargement…" },
    },
  },
  pt: {
    translation: {
      brand: "EventHub",
      subbrand: "Dakar · 7–15 de outubro de 2026",
      nav: { browse: "Sessões", myBookings: "Minhas reservas", media: "Mídia", admin: "Admin", scanner: "Scan Porta" },
      filters: { all: "Todos", workshop: "Oficinas", training: "Formações", side_event: "Eventos paralelos" },
      day: "Dia",
      hero: {
        eyebrow: "UM LINK · TODOS OS EVENTOS",
        title: "Um assento de concierge, reservado para si.",
        sub: "Explore oficinas, formações e eventos paralelos. Reserve via WhatsApp. Check-in com QR.",
        cta: "Ver sessões", bulk: "Reservar todos",
      },
      featured: {
        badge: "Destaque",
        dates: "7 – 15 de outubro de 2026",
        session_tag: "89.ª Sessão Ordinária · CADHP",
        title: "Fórum sobre a Participação das ONGs na 89",
        title_suffix: ".ª Sessão Ordinária da Comissão Africana dos Direitos Humanos e dos Povos",
        subtitle: "Eventos paralelos de Dakar · Sessões, oficinas & formações",
        theme_label: "Tema · 2026",
        theme_scope: "Agenda 2063 da União Africana",
        theme_quote: "« Garantir a disponibilidade sustentável de água e sistemas seguros de saneamento para alcançar as metas da Agenda 2063. »",
        two_venues: "Dakar, Senegal · Dois locais anfitriões",
        reserve_multiple: "RESERVAR VÁRIOS EVENTOS",
      },
      session: {
        capacity: "Capacidade", reserved: "Reservado", available: "Disponível", limited: "Limitado",
        full: "Cheio · Lista de espera", room: "Sala", facilitator: "Facilitador",
        reserve: "Reservar", starts: "Início",
      },
      otp: {
        title: "Verificação WhatsApp",
        sub: "Enviaremos um código de 6 dígitos ao seu WhatsApp.",
        phonePlaceholder: "+220 XXX XXXX", send: "Enviar código",
        codeLabel: "Insira o código de 6 dígitos",
        namePlaceholder: "Nome / Delegação", confirm: "Confirmar reserva", resend: "Reenviar",
        demoNotice: "MODO DEMO — o código aparece aqui. Em produção chega via WhatsApp.",
      },
      overlap: {
        title: "Conflito de horário", body: "Esta sessão sobrepõe reservas existentes. Continuar?",
        conflicts: "Conflitos", cancel: "Cancelar", continue: "Reservar mesmo assim",
      },
      bookings: {
        title: "Minhas reservas", empty: "Sem reservas. Escolha uma sessão.",
        qr: "Bilhete QR", cancel: "Cancelar",
        exportIcs: ".ics", exportGoogle: "Google", exportApple: "Apple",
        waitlisted: "Lista de espera — #{{n}}", confirmed: "Confirmada",
        loadPrompt: "Insira o número WhatsApp", load: "Carregar",
      },
      admin: {
        title: "Consola admin", login: "Entrar com Google", loggedInAs: "Sessão como",
        logout: "Sair", dashboard: "Painel", sessions: "Sessões", walkin: "Presencial",
        media: "Mídia", reports: "Relatórios", admins: "Administradores",
        totals: { bookings: "Confirmadas", waitlist: "Em espera", checkins: "Check-ins", no_show: "Faltas" },
        exportCsv: "Exportar CSV", walkinTitle: "Registo presencial",
        addSession: "Nova sessão", capacity: "Capacidade", reserved: "Reservado",
      },
      scanner: { title: "Check-in porta", placeholder: "Cole o token QR", check: "Validar",
        ok: "Bem-vindo!", duplicate: "Já registado", notfound: "Bilhete não encontrado" },
      media: { title: "Mídia & Agenda", empty: "Sem mídia." },
      common: { close: "Fechar", cancel: "Cancelar", loading: "Carregando…" },
    },
  },
  ar: {
    translation: {
      brand: "EventHub",
      subbrand: "داكار · 7–15 أكتوبر 2026",
      nav: { browse: "الجلسات", myBookings: "حجوزاتي", media: "الوسائط", admin: "الإدارة", scanner: "بوابة الدخول" },
      filters: { all: "الكل", workshop: "ورش عمل", training: "تدريبات", side_event: "فعاليات موازية" },
      day: "اليوم",
      hero: {
        eyebrow: "رابط واحد · جميع الفعاليات",
        title: "مقعد محجوز خصيصاً لكم.",
        sub: "تصفح ورش العمل والتدريبات والفعاليات. احجز عبر واتساب. سجّل الدخول برمز QR.",
        cta: "استعراض الجلسات", bulk: "احجز كل الفعاليات",
      },
      featured: {
        badge: "المميّز",
        dates: "7 – 15 أكتوبر 2026",
        session_tag: "الدورة العادية الـ89 · اللجنة الأفريقية",
        title: "منتدى مشاركة المنظمات غير الحكومية في الدورة العادية الـ89",
        title_suffix: " للجنة الأفريقية لحقوق الإنسان والشعوب",
        subtitle: "فعاليات داكار الموازية · جلسات وورش عمل وتدريبات",
        theme_label: "الموضوع · 2026",
        theme_scope: "أجندة 2063 للاتحاد الأفريقي",
        theme_quote: "«ضمان توافر المياه المستدام وأنظمة الصرف الصحي الآمن لتحقيق أهداف أجندة 2063.»",
        two_venues: "داكار، السنغال · موقعان مضيفان",
        reserve_multiple: "احجز فعاليات متعددة",
      },
      session: {
        capacity: "السعة", reserved: "محجوز", available: "متاح", limited: "محدود",
        full: "ممتلئ · قائمة الانتظار", room: "القاعة", facilitator: "الميسّر",
        reserve: "احجز مقعد", starts: "يبدأ",
      },
      otp: {
        title: "تحقق واتساب", sub: "سنرسل رمزاً من 6 أرقام إلى رقم واتساب.",
        phonePlaceholder: "+220 XXX XXXX", send: "إرسال الرمز",
        codeLabel: "أدخل الرمز المكون من 6 أرقام",
        namePlaceholder: "الاسم الكامل / الوفد", confirm: "تأكيد الحجز", resend: "إعادة الإرسال",
        demoNotice: "وضع تجريبي — يظهر الرمز هنا. في الإنتاج يصل عبر واتساب.",
      },
      overlap: {
        title: "تعارض في المواعيد",
        body: "تتعارض هذه الجلسة مع حجوزات قائمة. متابعة؟",
        conflicts: "التعارضات", cancel: "إلغاء", continue: "متابعة الحجز",
      },
      bookings: {
        title: "حجوزاتي", empty: "لا توجد حجوزات بعد.",
        qr: "تذكرة QR", cancel: "إلغاء",
        exportIcs: ".ics", exportGoogle: "Google", exportApple: "Apple",
        waitlisted: "قائمة الانتظار — #{{n}}", confirmed: "مؤكد",
        loadPrompt: "أدخل رقم واتساب", load: "تحميل",
      },
      admin: {
        title: "لوحة الإدارة", login: "الدخول بجوجل", loggedInAs: "مسجّل كـ",
        logout: "خروج", dashboard: "لوحة القيادة", sessions: "الجلسات", walkin: "حضور مباشر",
        media: "الوسائط", reports: "التقارير", admins: "المسؤولون",
        totals: { bookings: "المؤكدة", waitlist: "في الانتظار", checkins: "دخول", no_show: "غياب" },
        exportCsv: "تصدير CSV", walkinTitle: "تسجيل حضور مباشر",
        addSession: "إضافة جلسة", capacity: "السعة", reserved: "محجوز",
      },
      scanner: { title: "التحقق عند الباب", placeholder: "الصق رمز QR", check: "تحقق",
        ok: "مرحباً!", duplicate: "تم التسجيل مسبقاً", notfound: "لم يتم العثور على التذكرة" },
      media: { title: "الوسائط والأجندة", empty: "لا توجد وسائط." },
      common: { close: "إغلاق", cancel: "إلغاء", loading: "جارٍ التحميل…" },
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    supportedLngs: ["en", "fr", "pt", "ar"],
    interpolation: { escapeValue: false },
    detection: { order: ["localStorage", "navigator"], caches: ["localStorage"] },
  });

export const setLang = (lng) => {
  i18n.changeLanguage(lng);
  const isRTL = lng === "ar";
  document.documentElement.dir = isRTL ? "rtl" : "ltr";
  document.documentElement.lang = lng;
};

// initial dir
const cur = i18n.language || "en";
document.documentElement.dir = cur === "ar" ? "rtl" : "ltr";
document.documentElement.lang = cur;

export default i18n;
